<script>
import accountApiMixin from "@/mixin/accountMixin";
import getFactorExpensesApi from "./getFactorExpensesApi";
import wareApiMixin from "@/mixin/wareApi";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import date from "@/components/mcomponents/cleave/Date";
import mtime from "@/components/mcomponents/cleave/Time";
import FactorMixin from "@/views/panel/factor/mixin";

import { MFormMixin } from "@/components/m-form";
import { parseInt } from "lodash";

export default {
  components: { money, date, mtime },
  mixins: [
    MFormMixin,
    formsMixin,
    accountApiMixin,
    wareApiMixin,
    getFactorExpensesApi,
    FactorMixin,
  ],
  props: {
    isPreFactor: {
      required: true,
      type: Boolean,
    },
    type: {
      required: true,
    },
    id: {
      default: false,
    },
    backFrom: {
      default: null,
    },
    showOldUi: {
      default: false,
    },
  },
  data() {
    return {
      hasList: false,
      transactionsDialog: false,
      baseUrl: "factors/factors",
      appendSlash: true,
      rowKey: "ware",
      hasIdProp: true,
      hasLock: true,
      personDialog: false,
      exportsDialog: false,
      factorExpensesDialog: false,
      expensesDialog: false,
      discountDialog: false,
      factorExpensesCopy: [{}],
      expensesToDelete: [],
      filters: {},
      fpi_headers: [
        {
          text: "* نام کالا",
          value: "ware.name",
          align: "center",
          sortable: false,
          filterable: true,
        },
        {
          text: "* واحد",
          value: "unit.name",
          align: "center",
          sortable: false,
          filterable: true,
        },
        {
          text: "* انبار",
          value: "warehouse.name",
          align: "center",
          sortable: false,
          filterable: true,
          width: "150px",
        },
        {
          text: "* تعداد",
          value: "unit_count",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "* قیمت واحد",
          value: "fee",
          align: "center",
          sortable: false,
          filterable: true,
        },
        {
          text: "مبلغ کل",
          value: "total",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "توضیحات",
          value: "explanation",
          align: "center",
          sortable: false,
          filterable: true,
        },
        {
          text: "",
          value: "deleteRow",
          align: "center",
          sortable: false,
          filterable: false,
          width: "40px",
        },
      ],

      nothing: [],
      exportOptions: {
        has_tax: false,
        summarized: false,
        hide_expenses: false,
        hide_remain: false,
        show_default_text: true,
      },

      discountPercent: null,

      pricesDialog: false,
      priceWare: null,
      pricesFilters: {
        ware: null,
        factor__account: null,
        factor__floatAccount: null,
        factor__type__in: null,
      },

      priceMenus: {},

      pricesHeaders: [
        {
          text: "شماره فاکتور",
          value: "factor.code",
        },
        {
          text: "تاریخ",
          value: "factor.date",
          type: "date",
        },
        {
          text: "تعداد",
          value: "count",
          type: "numeric",
        },
        {
          text: "واحد",
          value: "unit.name",
        },
        {
          text: "فی",
          value: "fee",
          type: "numeric",
          sortable: false,
        },
        {
          text: "مبلغ کل",
          value: "total_value",
          type: "numeric",
          sortable: false,
        },
      ],

      calculatorDialog: false,
      row: null,
      mobileRow: null,
      mobileRowIndex: null,
      mobileDeleteAllRowDialog: false,
      mobileNewRowDialog: false,
      mobileDeleteRowDialog: false,
      mobileNewRowDialogTitle: "ثبت کالا",
    };
  },
  computed: {
    rowsHaveTax() {
      for (let i in this.rows) {
        if (this.rows[i].ware && this.rows[i].ware.base_ware_value_added_tax > 0) {
          return true;
        }
      }
      return false;
    },
    totalAmount() {
      let total = 0;
      for (let i in this.rows) {
        if (this.rows[i].unit_count && this.rows[i].fee) {
          total += this.rows[i].unit_count * this.rows[i].fee;
        }
      }
      return total;
    },
    totalAfterDiscountValue() {
      let total = 0;
      for (let i in this.rows) {
        if (this.rows[i].unit_count && this.rows[i].fee) {
          total += this.rows[i].unit_count * this.rows[i].fee;
          if (parseInt(this.rows[i].discountValue)) {
            total -= parseInt(this.rows[i].discountValue);
          }
        }
      }
      return total;
    },
    inputTableHeight() {
      let height = screen.height - 630;
      if (!this.showOldUi) {
        height += 180;
      }

      if (this.type == "fpi") {
        height = screen.height - 460;
      }
      if (this.type == "rc" || this.type == "rm") {
        height = screen.height - 450;
      }
      return height + "px";
    },
    showCalculatorBtn() {
      return false;
    },
    RoRFactorTypes() {
      return {
        rc: {
          factor: {
            label: "خرید",
            type: "buy",
          },
          backFactor: {
            label: "برگشت از فروش",
            type: "backFromSale",
          },
        },
        rm: {
          factor: {
            label: "فروش",
            type: "sale",
          },
          backFactor: {
            label: "برگشت از خرید",
            type: "backFromBuy",
          },
        },
      };
    },
    preFactor() {
      for (let row of this.rows) {
        if (row.id && row.preFactorItem) {
          let isPreFactor = row.preFactorItem.factor__is_pre_factor;
          let factorType = row.preFactorItem.factor__type;

          let label = "";
          if (isPreFactor) label = "پیش فاکتور";
          else if (factorType == "rm") label = "حواله";
          else if (factorType == "rc") label = "رسید";

          return {
            label: label,
            id: row.preFactorItem.factor__id,
            isPreFactor: isPreFactor,
            type: factorType,
          };
        }
      }
      return null;
    },
    isConverted() {
      for (let row of this.rows) {
        if (row.id && row.factorItem) return true;
      }
      return false;
    },
    hasSelect() {
      return this.isPreFactor || this.isRoR;
    },
    canSubmit() {
      if (this.item.id || this.isFpi) {
        return this.hasPerm("update", this.permissionBasename, this.item);
      } else {
        return this.hasPerm("create", this.permissionBasename, this.item);
      }
    },
    permissionBasename() {
      let basenames = {
        buy: "buyFactor",
        sale: "saleFactor",
        backFromBuy: "backFromBuyFactor",
        backFromSale: "backFromSaleFactor",
        fpi: "firstPeriodInventory",
        cw: "consumptionWareFactor",
        rc: "receipt",
        rm: "remittance",
        p: "production",
      };
      return basenames[this.type];
    },
    accountType() {
      if (this.isCw || this.isFpi || this.isProduction) return "level3";
      else return this.accountUsage.PERSON;
    },
    createUrl() {
      return "factors/factors/";
    },
    updateUrl() {
      return `factors/factors/${this.id}/`;
    },
    listRoute() {
      return {
        name: "FactorsList",
        params: {
          isPreFactor: this.isPreFactor,
          type: this.type,
        },
      };
    },
    isRoR() {
      // is Receipt or Remittance
      return ["rc", "rm"].includes(this.type);
    },
    isFpi() {
      return this.type == "fpi";
    },
    isCw() {
      return this.type == "cw";
    },
    isBuy() {
      return this.type == "buy";
    },
    isSale() {
      return this.type == "sale";
    },
    isBack() {
      return ["backFromBuy", "backFromSale"].includes(this.type);
    },
    isBackFromBuy() {
      return this.type == "backFromBuy";
    },
    isBackFromSale() {
      return this.type == "backFromSale";
    },
    isProduction() {
      return this.type == "p";
    },
    title() {
      return this.setDocumentTitle(this.getFactorTitle(this.type, this.isPreFactor));
    },
    showDiscount() {
      return !this.isFpi && !this.isCw && !this.isRoR && !this.isProduction;
    },
    showTax() {
      return !this.isFpi && !this.isCw && !this.isRoR && !this.isProduction;
    },
    showFactorExpenses() {
      return this.hasFeature("FACTOR_EXPENSES") && !this.isFpi && !this.isPreFactor && !this.isProduction;
    },
    hasTransaction() {
      return this.id && !this.isFpi && !this.isCw && !this.isPreFactor && !this.isProduction;
    },
    hasReverseFactor() {
      return this.id && (this.isBuy || this.isSale) && !this.isPreFactor;
    },
    hasBijak() {
      return ["buy", "backFromBuy"].includes(this.type) || this.isFpi;
    },
    reverseLabel() {
      let labels = {
        sale: "فاکتور برگشت از فروش ",
        buy: "فاکتور برگشت از خرید ",
      };
      return labels[this.type];
    },
    paymentsSum() {
      let sum = 0;
      if (this.item.payments) {
        this.item.payments.forEach((payment) => {
          sum += +payment.value;
        });
      }
      return sum;
    },
    canSubmitTransaction() {
      if (!this.id || this.isFpi || this.isCw || this.isPreFactor || this.isRoR || this.isProduction) return false;
      return this.item.paidValue < this.sum.total;
    },
    exportLinks() {
      let url =
        "reports/lists/factors/TEMP?form=factor&type=" +
        this.type +
        "&is_pre_factor=" +
        this.isPreFactor +
        "&id=" +
        this.id +
        "&token=" +
        this.token;
      url = this.endpoint(url);

      Object.keys(this.exportOptions).forEach((key) => {
        let value = this.exportOptions[key];
        url += `&${key}=${value}`;
      });

      let item = {
        html: url.replace("TEMP", "html"),
        pdf: url.replace("TEMP", "pdf"),
      };

      let receipt = {
        html: item.html + "&summarized=true&hide_prices=true&receipt=true",
        pdf: item.pdf + "&summarized=true&hide_prices=true&receipt=true",
      };

      return {
        item,
        receipt,
      };
    },
    sum() {
      let res = {
        sum: 0,
        afterDiscount: 0,
        discount: 0,
        afterTax: 0,
        count: 0,
        total: 0,
        expenses: 0,
      };
      this.rows.forEach((r) => {
        if (parseInt(this.rowSumAfterTax(r))) {
          res.sum += this.rowSumAfterTax(r);
        }
        if (parseInt(r.unit_count)) {
          res.count += parseInt(r.unit_count);
        }
      });
      this.item.expenses.forEach((e) => {
        res.expenses += +e.value;
      });

      res.afterDiscount = res.sum;
      res.total = res.afterDiscount + +this.item.taxValue;

      return res;
    },
    accountName() {
      if (this.isCw || this.isFpi || this.isRoR || this.isProduction) return "حساب";
      if (["buy", "backFromBuy"].includes(this.type)) {
        return "فروشنده";
      } else {
        return "مشتری";
      }
    },
    transactionLink() {
      return this.getFactorTransactionLink(this.item);
    },
    factorExpenseType() {
      if (this.isBuy || this.isBackFromSale) return "buy";
      else return "sale";
    },
    receiptLabel() {
      if (this.isSale || this.isBackFromBuy) return "حواله";
      else return "رسید";
    },
    quickTransactionOptions() {
      if (["buy", "backFromSale"].includes(this.type)) {
        return [
          {
            text: "وجه نقد سریع",
            codename: "quickCachePayment",
          },
          {
            text: "بانکی سریع",
            codename: "quickBankPayment",
          },
        ];
      } else {
        return [
          {
            text: "وجه نقد سریع",
            codename: "quickCacheReceive",
          },
          {
            text: "کارتخوان سریع",
            codename: "quickPosReceive",
          },
        ];
      }
    },

    factorVisitors() {
      let visitors = this.visitors.filter((o) => o.level == 3);
      let userVisitor = visitors.find((o) => o.user.id == this.user.id);
      if (userVisitor) {
        this.item.visitor = userVisitor.id;
        return [userVisitor];
      } else {
        return visitors;
      }
    },
    squareMetters() {
      let data = this.row.meta;
      return (this.row.meta.square_meters = +(data.length * data.width).toFixed(6));
    },
    totalSquareMetters() {
      let data = this.row.meta;
      return (this.row.meta.total_square_meters = +(this.row.meta.square_meters * data.count).toFixed(6));
    },
  },
  watch: {
    rows: {
      handler(newRows, oldRows) {
        this.setDefaultValues();
      },
      deep: true,
    },
    factorExpensesCopy: {
      handler() {
        let expense = this.factorExpensesCopy[this.factorExpensesCopy.length - 1];
        if (expense && expense.expense) {
          this.factorExpensesCopy.push({});
        }
      },
      deep: true,
    },
    "item.has_tax"() {
      if (this.item.has_tax == false) {
        this.item.taxPercent = 0;
        this.item.taxValue = 0;
      }
    },
    rowsHaveTax: {
      handler() {
        this.exportOptions.has_tax = this.rowsHaveTax
      },
      deep: true,
    },

  },
  mounted() {
    this.getVisitors();
    this.getUnits();
    this.getSalePriceTypes();
  },
  methods: {
    getItemByCode(code) {
      this.log("Get factor by code: ", code);
      return this.request({
        url: this.endpoint("factors/byCode"),
        method: "get",
        params: {
          code: code, type: this.type, isPreFactor: this.isPreFactor
        },
        success: (data) => {
          this.setItem(data);
        },
      });
    },

    getIsService() {
      if (["sale", "backFromSale", "cw"].includes(this.type)) {
        // show both wares & services
        return null;
      }
      return false;
    },
    getData() {
      this.getWarehouses();
      this.getFactorExpenses();
      if (this.isFpi) {
        this.getFirstPeriodInventory();
      } else if (this.backFrom) {
        this.getFactor(this.backFrom);
      }
    },
    addDiscount() {
      this.rows.forEach((r) => {
        if (r.ware) {
          r.discountPercent = this.discountPercent;
          this.updateRowDiscountValue(r);
        }
      });
      this.item.discountPercent = 0;
      this.discountDialog = false;
      this.discountPercent = 0;
    },
    getFirstPeriodInventory() {
      this.request({
        url: this.endpoint("factors/firstPeriodInventory"),
        method: "get",
        success: (data) => {
          if (!data.message) {
            this.setItem(data);
            this.isEditing = false;
          }
        },
      });
    },
    getItemTemplate() {
      return {
        account: {},
        hax_tax: false,
        taxValue: "",
        backFrom: null,
        expenses: [],
        date: undefined,
        time: undefined,
        is_pre_factor: this.isPreFactor,
        has_auto_sanad: true,
      };
    },
    getRowTemplate() {
      let explanation = "";
      if (this.isFpi) {
        explanation = "ثبت موجودی اول دوره";
      }
      return {
        discountValue: 0,
        discountPercent: "",
        tax_value: "",
        tax_percent: "",
        fee: "",
        count: null,
        unit_count: null,
        ware: null,
        unit: null,
        warehouse: null,
        explanation: explanation,
        is_selected: false,
        meta: {},
      };
    },
    getFactor(factorId) {
      return this.request({
        url: this.endpoint("factors/factors/" + factorId + "/"),
        method: "get",
        success: (data) => {
          this.setItem(data);
        },
      });
    },
    getItemByPosition(pos) {
      return this.request({
        url: this.endpoint("factors/factors/byPosition"),
        method: "get",
        params: {
          type: this.type,
          is_pre_factor: this.isPreFactor,
          id: this.item.id,
          position: pos,
        },
        success: (data) => {
          this.setItem(data, true);
        },
        error: (error) => {
          if (error.response.status == 404) {
            this.notify("فاکتور وجود ندارد", "warning");
          }
        },
      });
    },
    setProductionAccount() {
      let defaultAccount = this.getDefaultAccount("producedWareAccount");
      if (defaultAccount) {
        this.$set(this.item, "account", defaultAccount.account);
        this.$set(this.item, "floatAccount", defaultAccount.floatAccount);
        this.$set(this.item, "costCenter", defaultAccount.costCenter);
      }
    },
    openTransaction(transaction) {
      let routeData = this.$router.resolve({
        name: "TransactionForm",
        params: {
          type: transaction.type,
          id: transaction.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    getSerialized() {
      if (this.isProduction) {
        this.setProductionAccount();
      }

      let factor = this.copy(this.item);
      factor = this.extractIds(factor);
      factor.path = this.item.account.path;
      factor.has_tax = this.rowsHaveTax;

      let items = [];
      this.rows.forEach((row, i) => {
        if (i == this.rows.length - 1) return;
        let item = this.copy(row);
        item.count = this.convertToMainUnit(item.ware, item.unit_count, item.unit);
        item = this.extractIds(item);
        ["tax_value", "tax_percent"].forEach((k) => {
          if (item[k] == "") item[k] = 0;
        });
        items.push(item);
      });

      let expenses = [];
      this.item.expenses.forEach((row, i) => {
        // Should I put this?
        // if (i == this.rows.length - 1) return;
        let item = this.copy(row);
        item = this.extractIds(item);
        expenses.push(item);
      });

      delete factor.items;

      return {
        item: factor,
        items: {
          items: items,
          ids_to_delete: this.itemsToDelete,
        },
        expenses: {
          items: expenses,
          ids_to_delete: this.expensesToDelete,
        },
      };
    },
    definiteFactor(clearForm) {
      this.request({
        url: this.endpoint("factors/factors/definite/" + this.item.id),
        method: "post",
        success: (data) => {
          this.setItem(data);
          this.successNotify();
        },
      });
    },
    setDefaultValues() {
      let items = this.rows.filter((o) => o.ware);
      items.forEach((item) => {
        if (!this.isBuy && !item.fee) item.fee = item.ware.price;
        if (!item.warehouse) item.warehouse = item.ware.warehouse;
        item.sale_price = item.ware.price;
      });
    },
    validate(clearForm = false) {
      let isValid = true;

      if (!this.item.account.id) {
        this.notify(`${this.accountName} را انتخاب کنید`, "danger");
        isValid = false;
      }

      if (this.rows.length == 1) {
        this.notify(`لطفا حداقل یک ردیف وارد کنید`, "danger");
        isValid = false;
      }
      this.rows.forEach((r, i) => {
        if (i == this.rows.length - 1) return;
        if (!r.unit_count || r.unit_count == 0) {
          this.notify(`لطفا تعداد ردیف ${i + 1} را وارد کنید`, "danger");
          isValid = false;
        }
        if (r.fee == undefined || r.fee == "") {
          if (this.isCw || this.isRoR) r.fee = 0;
          else {
            this.notify(`لطفا قیمت واحد ردیف ${i + 1} را وارد کنید`, "danger");
            isValid = false;
          }
        }
        if (r.unit == undefined || r.unit == null) {
          this.notify(`لطفا واحد ردیف ${i + 1} را وارد کنید`, "danger");
          isValid = false;
        }
        if (!r.ware.is_service && !this.hasValue(r.warehouse)) {
          this.notify(`لطفا انبار ردیف ${i + 1} را وارد کنید`, "danger");
          isValid = false;
        }
        if (r.unit_count == undefined) {
          this.notify(`لطفا تعداد ردیف ${i + 1} را وارد کنید`, "danger");
          isValid = false;
        }
      });
      if (!isValid) return;

      ["taxPercent", "taxValue"].forEach((k) => {
        if (this.item[k] == "") this.item[k] = 0;
      });

      this.item.type = this.type;

      this.submit(clearForm);
    },
    setItem(item) {
      this.rows = item.items.sort((a, b) => a.order - b.order);

      if (this.backFrom && item.backFrom != this.backFrom) {
        let keysToCopy = [
          "account",
          "floatAccount",
          "costCenter",
          "date",
          "time",
          "has_tax",
          "taxValue",
          "taxPercent",
          "visitor",
          "path",
        ];

        for (let key of keysToCopy) {
          this.$set(this.item, key, item[key]);
        }
        this.item.type = this.type;
        this.item.backFrom = this.backFrom;

        this.rows.map((row) => {
          delete row.id;
          delete row.factor;
          return row;
        });
        this.item.expenses.map((expense) => {
          delete expense.id;
          delete expense.factor;
          return expense;
        });
      } else {
        this.item = item;
        if (this.id != item.id) {
          this.changeRouteTo(item.id, {
            type: item.type,
            isPreFactor: item.is_pre_factor,
          });
        } else {
          this.isEditing = false;
        }
      }

      this.rows.push(this.getRowTemplate());
      this.itemsToDelete = [];
    },
    deleteItemRow(index) {
      if (index == -1) {
        this.rows.forEach((row) => {
          if (row.id) this.itemsToDelete.push(row.id);
        });
        this.rows.splice(0, this.rows.length - 1);
      } else {
        let row = this.rows[index];
        if (row.id) this.itemsToDelete.push(row.id);
        this.rows.splice(index, 1);
      }
    },
    deleteExpenseRow(index) {
      let row = this.factorExpensesCopy[index];
      if (row.id) this.expensesToDelete.push(row.id);
      this.factorExpensesCopy.splice(index, 1);
    },
    rowSum(row) {
      if (!this.hasValue(row.fee) || !this.hasValue(row.unit_count)) return 0;
      return +row.fee * +row.unit_count;
    },
    rowDiscount(row) {
      if (!this.rowSum(row)) return 0;
      if (!this.hasValue(row.discountValue) && !this.hasValue(row.discountPercent)) return 0;
      if (this.hasValue(row.discountValue)) return +row.discountValue;
      else return +((this.rowSum(row) * +row.discountPercent) / 100).toFixed(2);
    },
    rowSumAfterDiscount(row) {
      return this.rowSum(row) - this.rowDiscount(row);
    },
    rowTax(row) {
      if (!this.rowSumAfterDiscount(row)) return 0;
      if (!this.hasValue(row.tax_value) && !this.hasValue(row.tax_percent)) return 0;
      if (this.hasValue(row.tax_value)) return +row.tax_value;
      else return +((this.rowSumAfterDiscount(row) * +row.tax_percent) / 100).toFixed(2);
    },
    rowSumAfterTax(row) {
      if (!this.rowTax(row)) return this.rowSumAfterDiscount(row);
      return this.rowSumAfterDiscount(row) + this.rowTax(row);
    },
    openFactorExpensesDialog() {
      if (this.item.expenses.length) {
        this.factorExpensesCopy = [];
        this.item.expenses.forEach((e) => {
          this.factorExpensesCopy.push(this.copy(e));
        });
      }
      this.factorExpensesDialog = true;
    },
    addExpenses() {
      let isValid = true;
      this.factorExpensesCopy.forEach((e, i) => {
        if (i == this.factorExpensesCopy.length - 1) return;
        if (!e.expense) {
          this.notify(`لطفا نام هزینه ردیف ${i + 1} را وارد کنید`, "danger");
          isValid = false;
        }
        if (!e.value || e.value == 0) {
          this.notify(`لطفا مبلغ ردیف ${i + 1} را وارد کنید`, "danger");
          isValid = false;
        }
        if (!e.account) {
          this.notify(`لطفا حساب پرداخت کننده ردیف ${i + 1} را وارد کنید`, "danger");
          isValid = false;
        }
        if (e.account && e.account.floatAccountGroup && !e.floatAccount) {
          this.notify(`لطفا حساب شناور ردیف ${i + 1} را وارد کنید`, "danger");
          isValid = false;
        }
      });

      if (!isValid) return;

      this.factorExpensesDialog = false;
      this.item.expenses = this.copy(this.factorExpensesCopy);
      this.item.expenses.pop();
      this.factorExpensesCopy = [{}];
    },
    reverseFactor() {
      let rows = this.copy(this.rows);
      let account = this.copy(this.item.account);

      this.$router.push(this.getReverseFactorLink(this.item).to);

      this.$nextTick(() => {
        this.item.account = account
        this.rows = [];
        for (const row of rows) {
          if (row.id) delete row.id;
          this.rows.push({
            ...row,
          });
        }
      });
    },
    showPrices(ware) {
      this.priceWare = ware;
      if (this.item.account) {
        this.pricesFilters.factor__account = this.item.account.id;
        if (this.item.floatAccount) this.pricesFilters.factor__floatAccount = this.item.floatAccount.id;
        if (this.item.costCenter) this.pricesFilters.factor__costCenter = this.item.costCenter.id;
      }
      this.pricesFilters.ware = ware.id;
      this.pricesFilters.factor__type__in = this.type;
      this.pricesDialog = true;
    },
    getWarePrices(row) {
      if (row.ware && row.unit) {
        let salePrices = row.ware.salePrices;
        let unit = row.unit;
        let prices = salePrices.filter((o) => o.unit == unit.id)[0].prices;
        let result = [];
        for (let salePriceTypeId of Object.keys(prices)) {
          let salePriceType = this.salePriceTypes.filter((o) => o.id == salePriceTypeId)[0];
          if (salePriceType) {
            result.push({
              id: salePriceTypeId,
              price: prices[salePriceTypeId],
              name: salePriceType.name,
            });
          }
        }
        return result;
      } else {
        return [];
      }
    },
    updateRowFee(row) {
      if ((this.isSale || this.isBackFromBuy) && this.item.account && row.ware && row.unit) {
        let defaultSalePriceType = this.item.account.defaultSalePriceType;
        let prices = this.getWarePrices(row);
        let price = prices.find((o) => o.id == defaultSalePriceType.id);
        if (price) {
          row.fee = price.price;
        } else {
          row.fee = null;
        }
      } else {
        row.fee = null;
      }
    },
    createQuickTransaction(codename) {
      this.request({
        url: this.endpoint("transactions/quickFactorTransaction"),
        method: "post",
        data: {
          factor_id: this.id,
          default_account_codename: codename,
        },
        success: (data) => {
          this.setItem(data);
          this.successNotify();
        },
      });
    },
    getFeeSuffix(row) {
      let price = this.getWarePrices(row).find((o) => o.price == row.fee);
      if (price) return price.name;
      return undefined;
    },
    clearRow(i) {
      let template = this.getRowTemplate();
      Object.keys(template).forEach((key) => {
        if (key == "ware") return;
        this.rows[i][key] = template[key];
      });
      this.rows[i].tax_percent = this.rows[i].ware.base_ware_value_added_tax;
    },
    convertPreFactorToFactor() {
      this.rows = this.rows.filter((o) => o.id && o.preFactorItem == null && o.is_selected);

      this.rows = this.rows.map((o) => {
        o.preFactorItem = o.id;
        o.id = null;
        return o;
      });
      this.rows.push(this.getItemTemplate());

      this.item.id = null;
      this.item.is_pre_factor = false;

      this.submit(false);
    },
    getFactorItemLink(row) {
      let factorItem = row.factorItem;

      let to = {
        name: "FactorForm",
        params: {
          id: factorItem.factor_id,
          type: factorItem.factor_type,
          is_pre_factor: false,
        },
      };

      let title = `تبدیل شده به فاکتور شماره ${factorItem.factor_code} ردیف ${+factorItem.order + 1}`;

      let text = factorItem.factor_code;

      return {
        to,
        title,
        text,
      };
    },
    convertRoRToFactor(factorType) {
      let rows = this.rows.filter((o) => o.id && o.preFactorItem == null && o.is_selected);

      rows = rows.map((o) => {
        o.preFactorItem = o.id;
        o.id = null;
        return o;
      });

      let item = this.copy(this.item);
      item.id = null;
      item.factorType = factorType;

      this.$router.push({
        to: "FactorForm",
        params: {
          id: null,
          type: factorType,
          isPreFactor: false,
        },
      });

      this.$nextTick(() => {
        this.item = item;

        this.rows = [];
        for (const row of rows) {
          this.rows.push({
            ...row,
          });
        }
      });
    },
    openCalculatorDialog(row) {
      this.row = row;
      this.calculatorDialog = true;
    },
    setCalculatorData() {
      let meta = this.row.meta;
      if (!meta.static_value) this.row.unit_count = meta.total_square_meters;
      this.row.explanation = `قطر: ${meta.diameter}، طول: ${meta.length}، عرض: ${meta.width}، تعداد: ${meta.count}، متر مربع: ${meta.square_meters}، متر مربع کل: ${meta.total_square_meters}`;
      this.calculatorDialog = false;
    },
    updateRowDiscountValue(row) {
      if (this.hasValue(row.discountPercent)) {
        row.discountValue = +((this.rowSum(row) * +row.discountPercent) / 100).toFixed(2);
      } else {
        row.discountValue = 0;
      }
    },
    updateRowDiscountPercent(row) {
      if (this.hasValue(row.discountValue)) {
        row.discountPercent = +(+row.discountValue / (this.rowSum(row) / 100)).toFixed(2);
      } else {
        row.discountPercent = 0;
      }
    },
    updateRowTaxValue(row) {
      if (this.hasValue(row.tax_percent)) {
        row.tax_value = +((this.rowSumAfterDiscount(row) * +row.tax_percent) / 100).toFixed(2);
      } else {
        row.tax_value = 0;
      }
    },
    updateRowTaxPercent(row) {
      if (this.hasValue(row.tax_value)) {
        row.tax_percent = +(+row.tax_value / (this.rowSum(row) / 100)).toFixed(2);
      } else {
        row.tax_percent = 0;
      }
    },

    removeTax(is_tax) {
      if (!is_tax) {
        for (let i in this.rows) {
          this.rows[i].tax_percent = 0;
          this.rows[i].tax_value = 0;
        }
      }
    },
  },
};
</script>
